module.exports = __webpack_public_path__ + "media/images/story/typo/congratsNatural-4150f1d418f439335d3560a517e2411b.svg";